import {
  Avatar,
  Box,
  Divider,
  Flex,
  Heading,
  HStack,
  Stack,
  useColorModeValue,
} from '@chakra-ui/react';
import {
  DollarSign,
  FileText,
  LayoutDashboard,
  Network,
  ShoppingCart,
  UserCog,
  Users,
} from 'lucide-react';
import { useAuth } from '../../hooks/auth';
import { usePermissoes } from '../../services/hooks/usePermissoes';
import { Constants } from '../../shared/constants';
import { Capitalize } from '../../utils/capitalize';
import { NavLink } from './NavLink';
import { NavSection } from './NavSection';

export function SidebarNav() {
  const { user } = useAuth();
  const { permite } = usePermissoes();
  const { PERMISSAO_VER_HIERARQUIA, PERMISSAO_CONVIDAR_PARCEIROS } = Constants;

  const bg = useColorModeValue('gray.100', 'gray.900');
  const dividerColor = useColorModeValue('gray.300', 'gray');
  const chakraLinkColor = useColorModeValue('blue.600', 'blue.200');

  return (
    <Stack h="100%" align="flex-start">
      <Box w="100%" px="4" my="6">
        <HStack align="center" bg={bg} rounded="2xl" p="4" spacing="4">
          <Avatar size="md" name={Capitalize(user.name)} src={user.avatarUrl} />
          <Flex flexDir="column">
            <Heading fontSize="sm" fontWeight="medium">
              {Capitalize(user.name)}
            </Heading>
          </Flex>
        </HStack>
      </Box>

      <Divider borderColor={dividerColor} />

      <NavSection title="GERAL">
        <NavLink href="/dashboard" icon={LayoutDashboard} shouldMatchExactHref>
          Dashboard
        </NavLink>
        {/* <NavLink href="/vendas-erp" icon={ShoppingCart}>
          Vendas ERP
        </NavLink> */}
        <NavLink href="/certificados" icon={FileText}>
          Certificados
        </NavLink>
        {/* <NavLink href="/meus-clientes" icon={Users}>
          Meus Clientes
        </NavLink> */}
        {/* <NavLink href="/saques" icon={DollarSign}>
          Saques
        </NavLink> */}
      </NavSection>

      {permite(PERMISSAO_CONVIDAR_PARCEIROS) && (
        <NavSection title="Painel Admin">
          <NavLink href="/usuarios" icon={UserCog}>
            Usuários
          </NavLink>
          {permite(PERMISSAO_VER_HIERARQUIA) && (
            <NavLink href="/hierarquia" icon={Network}>
              Hierarquia
            </NavLink>
          )}
        </NavSection>
      )}
    </Stack>
  );
}
